import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorAchievementNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IAchievementModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IAchievementFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useAchievementHookNae(id: number) : IAchievementModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorAchievementNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "achievement",
        fields: IAchievementFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
